













































import { MLink, MModal, MRichText } from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";
import store, { modules } from "../store";

@Component({
  components: {
    MLink,
    MModal,
    MRichText,
  },
})
export default class PiedPageULaval extends Vue {
  private afficherPiedPageUlaval: boolean = false;
  private afficherPopUpConditions: boolean = false;

  protected async mounted(): Promise<void> {
    if (this.$msal.data.isAuthenticated) {
      try {
        // Récupère des items contenus dans une entité (table) du CDS
        await store.dispatch(
          modules.cds.actions.recupererDefinitionsVariablesEnv.name,
          { vm: this }
        );
        await store.dispatch(
          modules.cds.actions.recupererValeursVariablesEnv.name,
          { vm: this }
        );
        await store.dispatch(
          modules.cds.actions.recupererParametresPilotage.name,
          { vm: this }
        );
      } catch (_) {
        // Ne rien faire et n'afficher que l'aide et le copyright
      }
    }

    this.afficherPiedPageUlaval = true;
  }

  get courriel(): string | null {
    //Obtenir la clé de la définition de la variable d'environnement
    const definitionsVariable = store.state.cds.definitionsVariablesEnv.find(
      (definition) =>
        definition.nomVariableEnv ===
        store.state.applicatif.variableEnvCleCourrielContact
    );

    if (definitionsVariable !== undefined) {
      //Obtenir la valeur de la variable d'environnement pour le courriel
      const valeursVariable = store.state.cds.valeursVariablesEnv.find(
        (variableEnv) => variableEnv.definitionId === definitionsVariable.id
      );

      if (valeursVariable !== undefined) {
        return `mailto:${valeursVariable.valeur}?subject=Location de casier - Aide`;
      }
    }

    return null;
  }

  get urlAide(): string {
    return (
      this.recupererDonneePilotage(
        store.state.applicatif.pilotageCleSiteSIAide,
        true
      ) || "https://www.ulaval.ca/etudiants-actuels/etudes/location-de-casiers"
    );
  }

  get conditionsUtilisation(): string {
    return this.recupererDonneePilotage(
      store.state.applicatif.pilotageCleConditionsUtilisation,
      false
    );
  }

  get numeroVersion(): string {
    return process.env.VUE_APP_NUMERO_VERSION || "";
  }

  // TODO: Refactor (utilisé ailleurs)
  private recupererDonneePilotage(
    cle: string,
    retournerTexteCourt: boolean
  ): string {
    let donnee: string = "";

    const parametre = store.state.cds.parametresPilotage.find(
      (parametre) => parametre.nomParametre === cle
    );

    if (parametre !== undefined) {
      donnee = retournerTexteCourt
        ? parametre.valeurTexteCourt
        : parametre.valeurTexteLong;
    }

    return donnee;
  }

  private afficherConditionsUtilisation(event: Event): void {
    this.afficherPopUpConditions = true;

    event.preventDefault();
  }
}
